import { ElementKind } from './enums'
import { ActionCardData, AssessmentData } from './types'

function makeAssessmentsChecked(ac: ActionCardData) {
  ac.sections.forEach(sec => {
    sec.elements?.forEach(el => {
      if (el.kind !== ElementKind.ASSESSMENT) return
      const assessment = el as AssessmentData

      assessment.checked = assessment.checked ? assessment.checked : assessment.responses?.some(resp => resp.checked)
    })
  })
}

export default makeAssessmentsChecked
